var _circle, _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 54,
    stroke: "url(#paint0_linear_4475_42609)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 4.13357,
    strokeLinecap: "round",
    strokeDasharray: "30 16 10 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 10.4762C32.6496 10.4762 10.4766 32.6494 10.4766 60.0005C10.4766 87.3505 32.6493 109.523 60.0001 109.523C87.3509 109.523 109.524 87.3505 109.524 60.0005C109.524 32.6494 87.3507 10.4762 60.0001 10.4762Z",
    fill: "url(#paint1_linear_4475_42609)",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4475_42609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7835 60.0003C92.7835 78.1068 78.1057 92.784 59.9992 92.784C41.8933 92.784 27.2148 78.1068 27.2148 60.0003C27.2148 41.8938 41.8933 27.2159 59.9992 27.2159C78.1057 27.2159 92.7835 41.8938 92.7835 60.0003Z",
    fill: "url(#paint2_linear_4475_42609)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3996 65.1234C47.445 66.269 42.3203 68.6083 45.4416 71.5355C46.9663 72.9654 48.6645 73.9881 50.7995 73.9881H62.9821C65.1171 73.9881 66.8153 72.9654 68.34 71.5355C71.4613 68.6083 66.3366 66.269 64.382 65.1234C59.7987 62.4369 53.9829 62.4369 49.3996 65.1234Z",
    stroke: "url(#paint3_linear_4475_42609)",
    strokeWidth: 2.22886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1076 52.229C63.1076 55.6625 60.3242 58.4459 56.8907 58.4459C53.4572 58.4459 50.6738 55.6625 50.6738 52.229C50.6738 48.7955 53.4572 46.0121 56.8907 46.0121C60.3242 46.0121 63.1076 48.7955 63.1076 52.229Z",
    stroke: "url(#paint4_linear_4475_42609)",
    strokeWidth: 2.22886
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7695 50.2307C67.7695 50.2307 69.3238 51.0411 70.1009 52.229C70.1009 52.229 72.4322 47.5663 75.5406 46.0121",
    stroke: "url(#paint5_linear_4475_42609)",
    strokeWidth: 2.22886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4475_42609",
    x: 12.3558,
    y: 12.3569,
    width: 95.2865,
    height: 95.2861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.42953
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4475_42609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4475_42609",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4475_42609",
    x1: 6,
    y1: 11.4,
    x2: 130.654,
    y2: 39.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#16EB78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4475_42609",
    x1: 10.4766,
    y1: 15.4285,
    x2: 124.797,
    y2: 40.8562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#16EB78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4475_42609",
    x1: 59.9992,
    y1: 27.2159,
    x2: 59.9992,
    y2: 92.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4475_42609",
    x1: 44.457,
    y1: 63.6525,
    x2: 68.3926,
    y2: 75.8213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4475_42609",
    x1: 50.6738,
    y1: 46.6338,
    x2: 65.0249,
    y2: 49.8258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4475_42609",
    x1: 67.7695,
    y1: 46.3229,
    x2: 76.5073,
    y2: 48.7523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC45EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivate);
export default __webpack_public_path__ + "static/media/reactivate.6372ddbe1787116fbe0dbe5021f0767e.svg";
export { ForwardRef as ReactComponent };